<template>
  <div class="animated fadeIn">
    <logs-tags-list />
  </div>
</template>

<script>
import LogsTagsList from './components/list/LogsTagsList.vue'

export default {
  name: 'LogsTags',
  components: {
    LogsTagsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/auditoria/logs-tags/LogsTags.vue